// NOTE: mixin expects computed boolean property "hasChanges"

export default {
  watch: {
    hasChanges(state) {
      this.$store.commit("SET_PREVENT_NAV", state);
    }
  },

  mounted() {
    const onBeforeUnload = e => {
      if (!this.hasChanges) return;
      e.preventDefault();
      e.returnValue = "";
    };

    window.addEventListener("beforeunload", onBeforeUnload);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    });
  }
};
